import React from "react";
import { Routes, Route } from "react-router-dom";
import ReporteFacturasIndexPage from "../pages/ReporteFacturasIndexPage";
import ReporteFacturasTotalPage from "../pages/ReporteFacturasTotalPage";
import ReporteFacturasPorAnioPage from "../pages/ReporteFacturasPorAnioPage";
import ReporteFacturasPorAnioMesPage from "../pages/ReporteFacturasPorAnioMesPage";
import ReporteFacturasMoraPage from "../pages/ReporteFacturasMoraPage";
import ReporteFacturasDetalleInternoPage from "../pages/ReporteFacturasDetalleInternoPage";
import ReporteFacturasPorCodigoPage from "../pages/ReporteFacturasPorCodigoPage";

const ReporteFacturasRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<ReporteFacturasIndexPage />} />
      <Route path="total" element={<ReporteFacturasTotalPage />} />
      <Route path="por-anio" element={<ReporteFacturasPorAnioPage />} />
      <Route path="por-anio-mes" element={<ReporteFacturasPorAnioMesPage />} />
      <Route path="mora" element={<ReporteFacturasMoraPage />} />
      <Route path="detalle-interno" element={<ReporteFacturasDetalleInternoPage />} />
      <Route path="por-codigo" element={<ReporteFacturasPorCodigoPage />} />
    </Routes>
  );
};

export default ReporteFacturasRoutes;
